import template from './rememberPassword.html';
import './rememberPassword.scss';
/**
 * Handles the remember password form email validation and submission.
 */
export class RememberPasswordController {
  /**
   * @param {ngComponentScope} $scope To access the form as an `ngForm`.
   */
  constructor($scope) {
    'ngInject';

    /**
     * A local reference for the component scope.
     * @type {ngComponentScope}
     */
    this.$scope = $scope;
    /**
     * The form binding for the user email address.
     * @type {string}
     */
    this.email = '';
    /**
     * The error message generated when the form is being validated.
     * For the sake of only having one property with the error message, when the `error` binding
     * changes, its value gets also copied to this property. The alternative would be to overwrite
     * the binding value, but that doesn't sound right.
     * @type {string}
     */
    this.errorMessage = '';
  }
  /**
   * When the `error` binding changes, copy its value to the `errorMessage` property.
   * @param {Object}  changes       A dictionary with the bindings that were updated.
   * @param {?Object} changes.error A dictionary with the changes for the `error` binding.
   */
  $onChanges({ error }) {
    if (error && error.currentValue) {
      this.errorMessage = error.currentValue;
    }
  }
  /**
   * Validates the form when it gets submitted.
   */
  remember() {
    // Make sure the implementation is not processing something.
    if (!this.loading) {
      // Get the form instance.
      const { form } = this;
      // Make sure the ngForm validations passed.
      if (form.$valid) {
        // Clean the error message, in case there was one.
        this.errorMessage = '';
        // Send the email address to the callback.
        this.onRemember({ email: this.email });
      } else if (form.$error.email) {
        // Check if the error is for the email address.
        this.errorMessage = 'Please enter a valid e-mail address';
      } else {
        // If the error can't be identified, set a generic error.
        this.errorMessage = 'Please complete the form';
      }
    }
  }
  /**
   * Gets the form instance.
   * @return {ngForm}
   */
  get form() {
    return this.$scope.ssoAuthBox_form;
  }
}
/**
 * Shows the _"remember your password"_ form.
 * @ngesdoc component
 * @ngcontroller {@link RememberPasswordController}
 * @ngname rememberPassword
 * @ngmodule auth
 * @ngbinding {string}   error            An error message to show. This is used after validating
 *                                        the credentials.
 * @ngbinding {boolean}  loading          Whether or not the component should show a loading
 *                                        indicator.
 * @ngbinding {boolean}  success          Whether or not the implementation finished the process.
 * @ngbinding {Function} onRemember       The callback the component calls when the user submits
 *                                        the form. It receives an `email` parameter.
 * @ngbinding {string}   goBackUrl        The URL for the `Go back` link.
 * @ngbinding {string}   privacyPolicyUrl The URL for the `Privacy policy` link.
 */
export default {
  controller: RememberPasswordController,
  template,
  bindings: {
    error: '<',
    loading: '<',
    success: '<',
    onRemember: '&',
    goBackUrl: '<',
    privacyPolicyUrl: '<',
  },
};
